import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbAlertConfig, NgbDropdownConfig, NgbModalConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectConfig } from '@ng-select/ng-select';
import { LanguageService } from './_shared/services/language.service';
import { NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(translate: TranslateService, languageService: LanguageService, alertConfig: NgbAlertConfig, tooltipConfig: NgbTooltipConfig,
              modalConfig: NgbModalConfig, selectConfig: NgSelectConfig, dropdownConfig: NgbDropdownConfig, private location: Location, private router: Router) {
    // translation config
    const lang = languageService.getLanguage(null);
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(lang.toLowerCase());
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    languageService.useLanguage(lang);

    // tooltip config
    tooltipConfig.container = 'body';

    // modal config
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;

    // select config
    selectConfig.bindLabel = 'label';
    selectConfig.bindValue = 'value';
    selectConfig.clearAllText = '';

    // dropdown config
    dropdownConfig.container = 'body';
  }

  ngOnInit(): void {
    // disabling browser back navigation

    // 1. blokkolja, ha más oldalról jöttünk
    history.pushState(null, '');

    fromEvent(window, 'popstate').subscribe((_) => {
      history.pushState(null, '');
      console.log('popstate');
    });

    // 2. blokkolja az egyes routok (view-k) közötti navigációt
    this.router.events
      .subscribe(event => {
        if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
          console.log('NavigationStart');
          // Angular navigates on the last route without reloading the page
          this.router.navigateByUrl(this.router.url, {replaceUrl: true});
        }
      });
  }
}
